module.exports = __webpack_public_path__ + "static/media/translate_icon_white.2341982b.svg";